import React, { ReactNode, createContext, useState, useEffect, useContext } from "react";
import { APIContext } from "./APIContext";
import UserDetailsViewModel from "./ViewModels/UserDetailsViewModel";

interface AppContext {
    userDetails: UserDetailsViewModel;
}

type AppProviderProps = { children: ReactNode }

export const AppContext = createContext<AppContext>({
    userDetails: new UserDetailsViewModel()
});

export default function AppProvider({ children }: AppProviderProps) {
    const { get } = useContext(APIContext);
    const [userDetails, setUserDetails] = useState(new UserDetailsViewModel());

    useEffect(() => {
        getUserDetails();
    }, []);

    const getUserDetails = () => {
        get('User', 'GetUserDetails', (data: UserDetailsViewModel) => setUserDetails(data));
    }

    return (
        <AppContext.Provider value={{ userDetails }}>
            {children}
        </AppContext.Provider>
    );
}